let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u6.png'),
  name: 'Four seasons',
  items: [],
};

export default itm;
